// extracted by mini-css-extract-plugin
export default {"leftCon":"index_leftCon_Ra-9Z"};